import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost, handleChangeValue, handlePatch } from '../../../../utils/AxiosUtil';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import NewAgainField from '../../../common/inputfields/NewAgainField';
import ErrorAwareAmountField from '../../../common/inputfields/ErrorAwareAmountField';
import { toDateFormat, trimSpaces } from '../../../../utils/Util';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import formatRelativeWithOptions from 'date-fns/esm/fp/formatRelativeWithOptions/index.js';
import MyCreatableAutocomplete from '../../../common/inputfields/MyAutocomplete';
import axios from 'axios';

class ModifyCarDayLocation extends Component {

    state = {
        selectedProject: this.props.row.projectId && { value: this.props.row.projectId, label: this.props.row.projectLocation },
        locationName: this.props.row.locationName,
        km: this.props.row.km,
        errors: new Map(),
    }

    componentDidMount() {
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/cardaylocation';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "carDayId": this.props.row.carDayId,
            "projectId": this.state.selectedProject?.value,
            "locationName": this.state.locationName,
            "km": trimSpaces(this.state.km)
        };
        await handlePatch(path, requestObject, this);
    };

    promiseProjectOptions = async () => {
        const params = {
            date: this.props.date
        }
        const response = await axios.get('/api/projects', { params })
        return response.data.map(resp => ({
            label: `${resp.publicId} - ${resp.location}(${resp.customers.map(obj => obj.name).join(', ')})`,
            value: resp.privateId,
            location: resp.location
        }));
    };

    handleProjectSelected = (e, v) => {
        this.setState({ selectedProject: v })
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    {this.props.row.projectId && <div className='input-group'>
                        <MyCreatableAutocomplete
                            value={this.state.selectedProject}
                            defaultvale={this.state.selectedProject}
                            getOptions={this.promiseProjectOptions}
                            onChange={this.handleProjectSelected}
                            label={'Project'}
                            required={false}
                        />
                    </div>}
                    {this.props.row.locationName && <div className='input-group'>
                        <ErrorAwareTextField
                            name="locationName"
                            label="Egyéb helyszín"
                            errors={this.state.errors}
                            value={this.state.locationName}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>}
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            name="km"
                            label="Megtett km"
                            errors={this.state.errors}
                            value={this.state.km}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Módosítás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyCarDayLocation);
